var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.007 11.011c.03-.719-.31-2.031-1.44-2H6.727l-.81-2.806a1.6 1.6 0 0 0-1.43-1.194h-2.47a.879.879 0 0 0-1.01.981v.193a.956.956 0 0 0 1.19.887h.89l1.76 6.276a2.174 2.174 0 0 0 2.16 1.663h9a2.155 2.155 0 0 0 2-1l1-3Zm-12.99 10.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm7 0a1.49 1.49 0 1 0 1.49-1.5 1.5 1.5 0 0 0-1.49 1.5Z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgBasket;